export const FEEDBACK_EDITOR_FORMATS = [
    'bold',
    'italic',
    'underline',
    'list',
    'align',
];

export const FEEDBACK_EDITOR_MODULES = {
    toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
    ],
};
